import { useWeb3React } from '@web3-react/core'
import { FC, useEffect } from 'react'
import styled from 'styled-components/macro'

const StyledWidget = styled.iframe`
  border: none;
  border-radius: 24px;
`

const WIDGET_ORIGIN = 'https://widget.genieswap.com'
const WIDGET_URL = `${WIDGET_ORIGIN}/#/?withoutTabs=buy&withoutTabs=mint`

export class WidgetConnector {
  private static instance: WidgetConnector | null = null

  private _iframe: HTMLIFrameElement | null = null

  public static getInstance(): WidgetConnector {
    if (!WidgetConnector.instance) {
      WidgetConnector.instance = new WidgetConnector()
    }
    return WidgetConnector.instance
  }

  public setIFrameRef(iframeRef: HTMLIFrameElement) {
    this._iframe = iframeRef
  }

  public postMessage<TPayload>(message: { type: string; payload: TPayload }) {
    if (this._iframe) {
      this._iframe.contentWindow?.postMessage(message, WIDGET_ORIGIN)
    }
  }
}

const WIDGET_CHANGING_CHAIN_ID = 'WIDGET_CHANGING_CHAIN_ID'
const PARENT_CHANGING_CHAIN_ID = 'PARENT_CHANGING_CHAIN_ID'

export const useWatchChain = (handleInIframeChange: (chainId: number) => void) => {
  const { chainId } = useWeb3React()

  useEffect(() => {
    if (chainId) {
      WidgetConnector.getInstance().postMessage({ type: PARENT_CHANGING_CHAIN_ID, payload: chainId })
    }
  }, [chainId])

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== WIDGET_ORIGIN) return

      if (event.data?.type === WIDGET_CHANGING_CHAIN_ID) {
        const newChainId = event.data.payload

        handleInIframeChange(newChainId)
      }
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [handleInIframeChange])
}

export const Widget: FC = () => {
  return (
    <StyledWidget
      ref={(el) => {
        if (el) {
          WidgetConnector.getInstance().setIFrameRef(el)
        }
      }}
      height="512px"
      width="440px"
      src={WIDGET_URL}
      allow="clipboard-read; clipboard-write"
    />
  )
}
